import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const CardFrontLabelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CardFrontLabels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idCard"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idCard"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idBoard"}},{"kind":"Field","name":{"kind":"Name","value":"idList"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"CardFrontLabels","document":CardFrontLabelsDocument}} as const;
export type CardFrontLabelsQueryVariables = Types.Exact<{
  idCard: Types.Scalars['ID']['input'];
}>;


export type CardFrontLabelsQuery = (
  { __typename: 'Query' }
  & { card?: Types.Maybe<(
    { __typename: 'Card' }
    & Pick<Types.Card, 'id' | 'idBoard' | 'idList'>
    & { labels: Array<(
      { __typename: 'Label' }
      & Pick<Types.Label, 'id' | 'name' | 'color'>
    )> }
  )> }
);

/**
 * __useCardFrontLabelsQuery__
 *
 * To run a query within a React component, call `useCardFrontLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCardFrontLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardFrontLabelsQuery({
 *   variables: {
 *      idCard: // value for 'idCard'
 *   },
 * });
 */
export function useCardFrontLabelsQuery(
  baseOptions: TrelloQueryHookOptions<
    CardFrontLabelsQuery,
    CardFrontLabelsQueryVariables
  >,
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: CardFrontLabelsDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    CardFrontLabelsQuery,
    CardFrontLabelsQueryVariables
  >(CardFrontLabelsDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useCardFrontLabelsLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    CardFrontLabelsQuery,
    CardFrontLabelsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CardFrontLabelsQuery,
    CardFrontLabelsQueryVariables
  >(CardFrontLabelsDocument, options);
}
export type CardFrontLabelsQueryHookResult = ReturnType<
  typeof useCardFrontLabelsQuery
>;
export type CardFrontLabelsLazyQueryHookResult = ReturnType<
  typeof useCardFrontLabelsLazyQuery
>;
export type CardFrontLabelsQueryResult = Apollo.QueryResult<
  CardFrontLabelsQuery,
  CardFrontLabelsQueryVariables
>;
